module.exports = __webpack_public_path__ + "media/src/assets/images/lps-eatout-ad3ca35b76c21113ed67ec1691b0196a.png";